import { create } from "zustand";

interface MenuStore {
  menuVisible: boolean;
  updateMenuVisible: (value: boolean) => void;
}

const useMenuStore = create<MenuStore>((set) => ({
  menuVisible: true,
  updateMenuVisible: (value) => set((state) => ({ menuVisible: value })),
}));

export default useMenuStore;
